import { Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useCallback, useEffect, useState } from 'react';
import './BannerBox.scss';
import Select from '../../@UI/Select';
import { useMatrixFlattener } from '../../../hooks/useMatrixFlattener';
import { Input } from '../../ContactModule/NewsletterContent/NewsletterContent';

const BannerBox = (props: any) => {
  try {
    const apiKey = 'AIzaSyAwujLgegYvocPgUrAhlzagwUvBkBlm75w';
    const googleApi =
      'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + apiKey;
    const [boxChange, setBoxChange] = useState(false);
    const [firstInput, setFirstInput] = useState('');
    const [firstInputKey, setFirstInputKey] = useState('');
    const [secondInput, setSecondInput] = useState('');
    const [secondInputKey, setSecondInputKey] = useState('');
    const [thirdInput, setThirdInput] = useState('');
    const [thirdInputKey, setThirdInputKey] = useState('');
    const [geoError, setGeoError] = useState(false);

    const flatten = useMatrixFlattener<any>();

    const [firstOptions, setFirstOptions] = useState<
      { title: { value: string }; subApps: string[] }[]
    >([]);
    const [secondOptions, setSecondOptions] = useState<
      { title: { value: string }; app: string; emissions: string[] }[]
    >([]);
    const [thirdOptions, setThirdOptions] = useState<
      { emission: string; id: string; app: string; subApp: string }[]
    >([]);

    const getAllOptions: () => {
      firstOptionsNew: { title: { value: string }; subApps: string[] }[];
      secondOptionsNew: {
        title: { value: string };
        app: string;
        emissions: string[];
      }[];
      thirdOptionsNew: {
        emission: string;
        id: string;
        app: string;
        subApp: string;
      }[];
    } = () => {
      const thirdOptionsNew = flatten(
        flatten(
          props.data?.map((item) =>
            item.subApps?.map((subItem) =>
              subItem?.emissions?.map((emission) => ({
                emission: emission.title,
                id: emission.guid,
                app: item.title.value,
                subApp: subItem.title.value,
              }))
            )
          )
        )
      );

      const secondOptionsNew = flatten(
        props.data?.map((item) =>
          item.subApps?.map((subItem) => ({
            title: { value: subItem.title.value },
            app: item.title.value,
            emissions: subItem?.emissions?.map((emission) => emission.title),
          }))
        )
      );

      const firstOptionsNew = props.data?.map((item) => ({
        title: { value: item.title.value },
        subApps: item.subApps?.map((subItem) => subItem.title.value),
      }));

      return {
        firstOptionsNew,
        secondOptionsNew,
        thirdOptionsNew,
      };
    };

    useEffect(() => {
      if (props?.data?.length === 0) return;
      const { firstOptionsNew, secondOptionsNew, thirdOptionsNew } =
        getAllOptions();
      setFirstOptions(firstOptionsNew);
      setSecondOptions(secondOptionsNew);
      setThirdOptions(thirdOptionsNew);
    }, [props.data]);

    useEffect(() => {
      if (
        firstInput?.length === 0 &&
        secondInput?.length === 0 &&
        thirdInput?.length === 0
      ) {
        const { firstOptionsNew, secondOptionsNew, thirdOptionsNew } =
          getAllOptions();
        setFirstOptions(firstOptionsNew);
        setSecondOptions(secondOptionsNew);
        setThirdOptions(thirdOptionsNew);
      }
    }, [firstInput, secondInput, thirdInput]);

    const [skipNextFirst, setSkipNextFirst] = useState<boolean>(false);
    const [skipNextSecond, setSkipNextSecond] = useState<boolean>(false);
    const [skipNextThird, setSkipNextThird] = useState<boolean>(false);

    useEffect(() => {
      if (props?.data?.length === 0) return;

      if (skipNextFirst) {
        setSkipNextFirst(false);
        return;
      }

      const { secondOptionsNew, thirdOptionsNew } = getAllOptions();

      // Filter if firstinput has value
      if (firstInput?.length > 0) {
        // If thirdinput has value apply also its filter
        if (thirdInput?.length === 0) {
          setSecondOptions(
            secondOptionsNew?.filter((item) => item.app === firstInput)
          );
        } else {
          setSecondOptions(
            secondOptionsNew
              ?.filter((item) => item.app === firstInput)
              ?.filter((item) => item.emissions.includes(thirdInput))
          );
        }
        // If secondInput has value apply also its filter
        if (secondInput?.length === 0) {
          setThirdOptions(
            thirdOptionsNew?.filter((item) => item.app === firstInput)
          );
        } else {
          setThirdOptions(
            thirdOptionsNew
              ?.filter((item) => item.app === firstInput)
              ?.filter((item) => item.subApp === secondInput)
          );
        }
      } else {
        // If firstInput has no value / reset

        // Still apply remaining filters if needed
        if (thirdInput?.length === 0) {
          setSecondOptions(secondOptionsNew);
        } else {
          setSecondOptions(
            secondOptionsNew?.filter((item) =>
              item.emissions.includes(thirdInput)
            )
          );
        }
        if (secondInput?.length === 0) {
          setThirdOptions(thirdOptionsNew);
        } else {
          setThirdOptions(
            thirdOptionsNew?.filter((item) => item.subApp === secondInput)
          );
        }
      }
    }, [firstInput]);

    useEffect(() => {
      if (props?.data?.length === 0) return;

      if (skipNextSecond) {
        setSkipNextSecond(false);
        return;
      }

      const { firstOptionsNew, thirdOptionsNew } = getAllOptions();

      if (secondInput?.length > 0) {
        if (thirdInput?.length === 0) {
          setFirstOptions(
            firstOptionsNew?.filter((item) =>
              item.subApps.includes(secondInput)
            )
          );
        } else {
          setFirstOptions(
            firstOptionsNew
              ?.filter((item) => item.subApps.includes(secondInput))
              ?.filter(
                (item) =>
                  thirdOptionsNew.filter((it) => it.emission === thirdInput)[0]
                    ?.app === item.title.value
              )
          );
        }
        if (firstInput?.length === 0) {
          setThirdOptions(
            thirdOptionsNew?.filter((item) => item.subApp === secondInput)
          );
        } else {
          setThirdOptions(
            thirdOptionsNew
              ?.filter((item) => item.subApp === secondInput)
              ?.filter((item) => item.app === firstInput)
          );
        }
      } else {
        if (thirdInput?.length === 0) {
          setFirstOptions(firstOptionsNew);
        } else {
          setFirstOptions(
            firstOptionsNew?.filter(
              (item) =>
                thirdOptionsNew.filter((it) => it.emission === thirdInput)[0]
                  ?.app === item.title.value
            )
          );
        }
        if (firstInput?.length === 0) {
          setThirdOptions(thirdOptionsNew);
        } else {
          setThirdOptions(
            thirdOptionsNew?.filter((item) => item.app === firstInput)
          );
        }
      }
    }, [secondInput]);

    useEffect(() => {
      if (props?.data?.length === 0) return;

      if (skipNextThird) {
        setSkipNextThird(false);
        return;
      }

      const { firstOptionsNew, secondOptionsNew, thirdOptionsNew } =
        getAllOptions();

      if (thirdInput?.length > 0) {
        if (secondInput?.length === 0) {
          setFirstOptions(
            firstOptionsNew?.filter(
              (item) =>
                thirdOptionsNew.filter((it) => thirdInput === it.emission)[0]
                  ?.app === item.title.value
            )
          );
        } else {
          setFirstOptions(
            firstOptionsNew
              ?.filter(
                (item) =>
                  thirdOptionsNew.filter((it) => thirdInput === it.emission)[0]
                    ?.app === item.title.value
              )
              ?.filter((item) => item.subApps.includes(secondInput))
          );
        }
        if (firstInput?.length === 0) {
          setSecondOptions(
            secondOptionsNew?.filter((item) =>
              item.emissions.includes(thirdInput)
            )
          );
        } else {
          setSecondOptions(
            secondOptionsNew
              ?.filter((item) => item.emissions.includes(thirdInput))
              ?.filter((item) => item.app === firstInput)
          );
        }
      } else {
        if (secondInput?.length === 0) {
          setFirstOptions(firstOptionsNew);
        } else {
          setFirstOptions(
            firstOptionsNew?.filter((item) =>
              item.subApps.includes(secondInput)
            )
          );
        }
        if (firstInput?.length === 0) {
          setSecondOptions(secondOptionsNew);
        } else {
          setSecondOptions(
            secondOptionsNew?.filter((item) => item.app === firstInput)
          );
        }
      }
    }, [thirdInput]);

    useEffect(() => {
      if (firstOptions?.length === 1) {
        setSkipNextFirst(true);
        setFirstInput(firstOptions[0].title.value);
        setFirstInputKey(firstOptions[0].title.value);
      } else {
        setSkipNextFirst(false);
      }
    }, [firstOptions]);
    useEffect(() => {
      if (secondOptions?.length === 1) {
        setSkipNextSecond(true);
        setSecondInput(secondOptions[0].title.value);
        setSecondInputKey(secondOptions[0].title.value);
      } else {
        setSkipNextSecond(false);
      }
    }, [secondOptions]);
    useEffect(() => {
      if (thirdOptions?.length === 1) {
        setSkipNextThird(true);
        setThirdInput(thirdOptions[0].emission);
        setThirdInputKey(thirdOptions[0].emission);
      } else {
        setSkipNextThird(false);
      }
    }, [thirdOptions]);

    const getOnlyUniqueItems: (items: any[]) => any[] = useCallback((items) => {
      let newItemsList = [];
      items?.forEach((item) => {
        if (
          newItemsList.filter((it) => it.emission !== item.emission)?.length ===
          newItemsList?.length
        ) {
          newItemsList.push(item);
        }
      });

      return newItemsList;
    }, []);

    useEffect(() => {
      if (!props.searchDropdownOne.data) {
        if (typeof window !== 'undefined' && typeof document != 'undefined' && boxChange) {
          if (!Array.from(document.scripts).find((e) => e.src === googleApi)) {
            const script = document.createElement('script');
            script.src = googleApi;
            script.addEventListener('load', () => {
              handleGoogleMapsLoad();
            });
            document.body.appendChild(script);
          }
        }
      }
    }, [boxChange]);

    function handleGoogleMapsLoad() {
      if(typeof document != 'undefined') {
        let autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('input-geolocation') as HTMLInputElement
        );
        autocomplete.addListener('place_changed', function () {
          let place = autocomplete.getPlace();
          setFirstInput(place.formatted_address);
        });
      }
    }

    const getPositionFromCoords = (coords) => {
      let initialLocation = new google.maps.LatLng(
        coords.latitude,
        coords.longitude
      );
      new google.maps.Geocoder().geocode(
        { location: initialLocation },
        function (data, status) {
          if (status === google.maps.GeocoderStatus.OK && data.length) {
            let formattedAddress = data[0].formatted_address;
            setFirstInput(formattedAddress);
          } else setGeoError(true);
        }
      );
    };

    const success = (pos) => {
      setGeoError(false);
      let coords = pos.coords;
      getPositionFromCoords(coords);
    };

    const error = () => {
      setGeoError(true);
    };

    function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(success, error);
      } else {
        setGeoError(true);
      }
    }

    function getUrlWithParams(
      baseUrl: string,
      query:
        | { address: string; serviceType: string; application: string }
        | {
            subapplications: string;
            emissions: string;
          }
    ) {
      if (typeof window !== 'undefined') {
        const url = new URL(baseUrl, window.location.origin);
        if (
          'address' in query &&
          'serviceType' in query &&
          'application' in query
        ) {
          url.searchParams[query.address ? 'set' : 'delete'](
            'address',
            query.address
          );
          url.searchParams[query.serviceType ? 'set' : 'delete'](
            'serviceType',
            query.serviceType
          );
          url.searchParams[query.application ? 'set' : 'delete'](
            'application',
            query.application
          );
        } else if ('subapplications' in query && 'emissions' in query) {
          let subAppGuid: string;
          props?.data?.forEach((app) => {
            app?.subApps?.forEach((subApp) => {
              if (subApp?.title?.value === query.subapplications) {
                subAppGuid = subApp.guid;
              }
            });
          });

          let emissionGuid: string;
          props?.data?.forEach((app) => {
            app?.subApps?.forEach((subApp) => {
              subApp.emissions.forEach((emission) => {
                if (emission.title === query.emissions) {
                  emissionGuid = emission.guid;
                }
              });
            });
          });

          url.searchParams[query.subapplications ? 'set' : 'delete'](
            'SubApplications',
            subAppGuid
          );
          url.searchParams[query.emissions ? 'set' : 'delete'](
            'Emissions',
            emissionGuid
          );
        }
        return url.href;
      } else {
        return baseUrl;
      }
    }

    function isInputFilledOrEmpty() {
      return (
        (firstInputKey && secondInputKey && thirdInputKey) ||
        (!firstInputKey && !secondInputKey && !thirdInputKey)
      );
    }
  
    function onBannerBoxCTAClick () {
      if(props?.useDirectLink?.value !== 'undefined' && props?.useDirectLink?.value === true) {
        window.location.href = props?.searchButton?.value?.href;
      }
      else {
        setBoxChange(true);}
    }

    const [engineHref, setEngineHref] = useState<string>('');

    useEffect(() => {
      if (!props.buttonDisabled) {
        setEngineHref(
          getUrlWithParams(props.searchButton.value.href, {
            subapplications: secondInputKey,
            emissions: thirdInputKey,
          })
        );
      }
    }, [secondInputKey, thirdInputKey]);

    return (
      <div
        className={`BannerBox__wrapper ${boxChange && 'BannerBox__boxChange'}`}
      >
        <div className={`BannerBox__internal`}>
          <RichText field={props.boxTitle} tag={'h3'} editable={true} />
          <RichText field={props?.boxDescription} tag={'p'} />
          <div
            className={'BannerBox__cta ga4-click-ui'}
            onClick={onBannerBoxCTAClick}
          >
            {props.ctaText.value}
          </div>
        </div>
        <div className={`BannerBox__hidden`}>
          <div className={'BannerBox__hidden_container'}>
            <Text
              field={props.searchBoxTitle}
              tag={'p'}
              className={'BannerBox__form_description'}
            />
            {!props.data ? (
              <>
                <Text
                  field={props.searchDropdownOne.title}
                  tag={'p'}
                  className={'BannerBox__input_title'}
                />
                <Input
                  id={'input-geolocation'}
                  placeholder={props.searchDropdownOne.placeholder}
                  Value={firstInput}
                  setValue={setFirstInput}
                  icon={'icon-geo'}
                  iconClick={getLocation}
                />
                {geoError && (
                  <div className={'BannerBox__geo_error_container'}>
                    <span className={'icon icon-error'} />
                    <p>Questo browser non supporta la geolocalizzazione.</p>
                  </div>
                )}
              </>
            ) : (
              <>
                <Text
                  field={props.searchDropdownOne.title}
                  tag={'p'}
                  className={'BannerBox__input_title'}
                />
                <Select
                  label={props.searchDropdownOne.placeholder.value}
                  onChange={(event) => {
                    setFirstInputKey(event);
                    setFirstInput(event);
                  }}
                  value={firstInputKey}
                  displayValue={firstInput}
                  isBlack={true}
                >
                  <>
                    <option value={''}></option>
                    {firstOptions.length > 0 &&
                      firstOptions.map((item, index) => {
                        return (
                          <option value={item.title.value} key={index}>
                            {item.title.value}
                          </option>
                        );
                      })}
                  </>
                </Select>
              </>
            )}
            <Text
              field={props.searchDropdownTwo.title}
              tag={'p'}
              className={'BannerBox__input_title'}
            />
            <Select
              label={props.searchDropdownTwo.placeholder.value}
              onChange={(event) => {
                if (props.data) {
                  setSecondInputKey(event);
                  setSecondInput(event);
                } else {
                  let key = props.searchDropdownTwo.data.find(
                    (i) => i.Name === event
                  )?.Value;

                  setSecondInputKey(event);
                  setSecondInput(key);
                }
              }}
              value={secondInputKey}
              displayValue={secondInput}
              isBlack={true}
            >
              <>
                <option value={''}></option>
                {!props.searchDropdownTwo?.data
                  ? secondOptions?.length > 0 &&
                    secondOptions?.map((item, index) => {
                      return (
                        <option value={item.title.value} key={index}>
                          {item.title.value}
                        </option>
                      );
                    })
                  : props.searchDropdownTwo?.data.map((option, index) => {
                      return (
                        <option value={option.Name} key={index}>
                          {option.Value}
                        </option>
                      );
                    })}
              </>
            </Select>
            <Text
              field={props.searchDropdownThree?.title}
              tag={'p'}
              className={'BannerBox__input_title'}
            />
            <Select
              label={props.searchDropdownThree?.placeholder?.value}
              onChange={(event) => {
                if (props.data) {
                  setThirdInputKey(event);
                  setThirdInput(event);
                } else {
                  let key = props.searchDropdownThree.data.find(
                    (i) => i.Name === event
                  )?.Value;
                  setThirdInputKey(event);
                  setThirdInput(key);
                }
              }}
              value={thirdInputKey}
              displayValue={thirdInput}
              isBlack={true}
            >
              <>
                <option value={''}></option>
                {!props.searchDropdownThree.data
                  ? thirdOptions?.length > 0 &&
                    getOnlyUniqueItems(thirdOptions).map((item, index) => {
                      return (
                        <option value={item.emission} key={index}>
                          {item.emission}
                        </option>
                      );
                    })
                  : props.searchDropdownThree?.data.map((option, index) => {
                      return (
                        <option value={option.Name} key={index}>
                          {option.Value}
                        </option>
                      );
                    })}
              </>
            </Select>
            {props.buttonDisabled ? (
              firstInput && secondInput && thirdInput ? (
                <Link
                  field={{
                    ...props.searchButton,
                    value: {
                      ...props.searchButton.value,
                      href: getUrlWithParams(props.searchButton.value.href, {
                        address: firstInput,
                        serviceType: secondInputKey,
                        application: thirdInputKey,
                      }),
                    },
                  }}
                  className={'BannerBox__cta'}
                  onClick={() => props?.gaTrack()}
                />
              ) : (
                <div
                  className={'BannerBox__cta BannerBox__disabled ga4-click-ui'}
                >
                  {props.searchButton.value.text}
                </div>
              )
            ) : (
              <>
                <Link
                  field={{
                    value: {
                      ...props.searchButton.value,
                      text: props.searchButton.value.text,
                      href: engineHref,
                    },
                  }}
                  onClick={() => props?.gaTrack()}
                  className={`BannerBox__cta ${
                    isInputFilledOrEmpty() ? '' : 'BannerBox__disabled'
                  }`}
                />
              </>
            )}
          </div>
        </div>
      </div>
    );
  } catch (error) {
    return <>{(error as Error)?.stack}</>;
  }
};

export default BannerBox;
